<template>
  <div>
    <homelogo />
    <v-img src="@/assets/Proyectos/imagen_header.jpg"></v-img>
    <v-row>
      <v-col lg="6" md="12" sm="12" cols="12">
        <v-img src="@/assets/Proyectos/cohete-parrafo_uno.jpg"></v-img>
        <h1 class="text-center titles px-10">Nuestros proyectos</h1>
      </v-col>
      <v-col lg="6" md="12" sm="12" cols="12">
        <p class="parrafos3 px-10">
          Nuestros proyectos buscan apoyar tanto a niños y niñas en edad escolar 
          que necesiten el recurso tecnológico, como a jardines infantiles, escuelas, 
          colegios, fundaciones, bibliotecas, hospitales que desarrollen algún tipo 
          de trabajo con  niños entre los 0 a 9 años de edad. 
          <!-- Todos estos proyectos son parte de nuestro compromiso social
          y están dedicados a niños de 0 a 9 años, "primera Infancia" de
          manera directa o indirecta, es decir las donaciones que nosotros
          entregamos muchas veces no es para el uso de ellos pero si
          para personas que se dedican a su cuidado, como hospitales,
          bibliotecas y colegios. -->
        </p>
      </v-col>
    </v-row>
    <v-img src="@/assets/Proyectos/imagen_parrafo_dos1.jpg">
      <v-row class="hidden-sm-and-down">
        <v-col lg="6" md="6" sm="12" cols="12"></v-col>
        <v-col lg="6" md="6" sm="12" cols="12" class="px-12 pt-12 mt-12">
          <h1 class="text-center titles">Computadores Viajeros</h1>
          <p class="parrafos1">
            Nuestro proyecto lleva computadores y equipos
            de computo a entidades, poblaciones y personas
            que se encargan del cuidado y bienestar de niños
            y niñas colombianos...
          </p>
          <v-btn
            rounded
            large
            class="white--text r-btn"
            color="orange"
            href="/computadoresviajeros"
          >Conoce más</v-btn>
        </v-col>
      </v-row>
    </v-img>
    <v-row class="hidden-md-and-up">
      <v-col cols="12" class="text-center pa-12">
        <h1 class="titles">Computadores Viajeros</h1>
        <p class="parrafos1">
          Nuestro proyecto lleva computadores y equipos
          de computo a entidades, poblaciones y personas
          que se encargan del cuidado y bienestar de niños
          y niñas colombianos...
        </p>
        <v-btn
          rounded
          large
          class="white--text r-btn"
          color="orange"
          href="/travelingComputers"
        >Conoce más</v-btn>
      </v-col>
    </v-row>
    <v-img src="@/assets/Proyectos/imagen_parrafo_tres.jpg">
      <v-row class="hidden-sm-and-down">
        <v-col lg="6" md="6" sm="12" cols="12" class="px-12 pt-12 mt-12">
          <h1 class="titles4">Reacondicionarte</h1>
          <p class="parrafos1 white--text">
            Este proyecto busca visibilizar aquellas iniciativas de emprendedores 
            que han hecho de los Residuos Electrónicos un Arte, transformándolos  
            en múltiples accesorios, objetos o aparatos útiles en distintos sectores.
            <!-- A través de este programa mostramos a la sociedad
            la importancia del reciclaje electrónico responsable
            en las empresas y en los hogares, fomentando de
            esta manera el reacondicionamiento. -->
          </p>
          <v-btn
            rounded
            large
            class="white--text r-btn"
            color="orange"
            href="/reacondicionar"
          >Conoce más</v-btn>
        </v-col>
      </v-row>
    </v-img>
    <v-row class="hidden-md-and-up">
      <v-col cols="12" class="text-center pa-12">
        <h1 class="titles">Reacondicionarte</h1>
        <p class="parrafos1">
          A través de este programa mostramos a la sociedad
          la importancia del reciclaje electrónico responsable
          en las empresas y en los hogares, fomentando de
          esta manera el reacondicionamiento.
        </p>
        <v-btn rounded large class="white--text r-btn" color="orange" href="/recondition">Conoce más</v-btn>
      </v-col>
    </v-row>
    <v-img src="@/assets/Proyectos/imagen_parrafo_cuatro.jpg">
      <v-row class="hidden-sm-and-down">
        <v-col lg="6" md="6" sm="12" cols="12" class="px-12 pt-8">
          <h1 class="titles">Comunidad Virtual</h1>
          <p class="parrafos1">
            Es un espacio creado para aquellas personas que desarrollan acciones
            educativas con niños en edad escolar, acá podras encontrar herramientas
            pedagógicas haciendo uso de las tecnologías de la información.
          </p>
          <v-row>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              large
              class="white--text r-btn"
              color="orange"
              href="/comunidadvirtual"
            >Conoce más</v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-img>
    <v-row class="hidden-md-and-up">
      <v-col cols="12" class="text-center pa-12">
        <h1 class="titles">Comunidad Virtual</h1>
        <p class="parrafos1">
          Es un espacio creado para aquellas personas que desarrollan acciones
          educativas con niños en edad escolar, acá podras encontrar herramientas
          pedagógicas haciendo uso de las tecnologías de la información.
        </p>
        <v-btn rounded large class="white--text r-btn" color="orange" href="/virtualCommunity">Conoce más</v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import homelogo from "@/components/homelogo/homelogo.vue";

export default {
  components: {
    homelogo
  },
  data: () => ({
    items: [
      {
        text: "RAEE.",
        icon: "@/assets/comoLoHacemos/como_lo_hacemos/raee_link.png",
        href: "#raee"
      },
      {
        text: "Reacondicionarte.",
        icon:
          "@/assets/comoLoHacemos/como_lo_hacemos/reacondicionarte_link.png",
        href: "#reacondicionar"
      },
      {
        text: "Economia circular",
        icon:
          "@/assets/comoLoHacemos/como_lo_hacemos/economia_circular_link.png",
        href: "#economiaCircular"
      },
      {
        text: "Cómo lo hacemos.",
        icon: "@/assets/comoLoHacemos/como_lo_hacemos/como_lo_hacemos_link.png",
        href: "#comoLoHacemos"
      }
    ],
    itemsRaee: [
      { icon: "", text: "Grandes Electrodomésticos." },
      { icon: "", text: "Equipos informáticos y telecomunicación." },
      { icon: "", text: "Pequeños Electrodomésticos" },
      { icon: "", text: "Aparatos electrónicos de consumo." },
      { icon: "", text: "Herramientas eléctricas." }
    ]
  }),
  methods: {
    onClick(e, item) {
      e.stopPropagation();

      if (item.to || !item.href) return;

      this.$vuetify.goTo(item.href.endsWith("!") ? 0 : item.href);
    },
    onclickreturn() {
      this.$vuetify.goTo("#init");
    }
  }
};
</script>
<style scoped>
.imglogo {
  position: absolute;
  width: 20%;
  /* background: transparent; */
  z-index: 99;
}
</style>